// pages/Unauthorized.js
const Unauthorized = () => <h2>🚫 You do not have access to this page</h2>;
export default Unauthorized;
